import Stack from '@mui/material/Stack';
import { useEffect, useState } from 'react';
import PromoTile from './PromoTile/PromoTile';
import {
    IEligibleOfferLocalStorage,
    IIneligibleOfferLocalStorage,
    getEligibleOfferFromStorage,
    getIneligibleOfferFromStorage,
} from '../../../../../ts/components/instant-offers/utils/instantOffersStorage';
import useAppState from '../../../../common/state/appState';
import { ANALYTICS_CONSTANTS } from '../../../../utilities/analytics';
import {
    buildScheduleEligibleOfferLink,
    buildScheduleIneligibleOfferLink,
} from '../../../../components/instant-offers/utils/constants';
import { ITrackingPayload } from '../../../../types/analytics';

let offerButtonHref = '/sell-my-car';

const HomeOptimizationTestPromoBanner = () => {
    const savedEligibleOffer = getEligibleOfferFromStorage();
    const savedIneligibleOffer = getIneligibleOfferFromStorage();
    const [eligibleOffer, setEligibleOffer] = useState<IEligibleOfferLocalStorage | null>();
    const [ineligibleOffer, setIneligibleOffer] = useState<IIneligibleOfferLocalStorage | null>();
    const isPrequalified = useAppState((state) => state.isPrequalified);
    const [eligibleOfferText, setEligibleOfferText] = useState('');
    const ineligibleOfferText = "We'd like to see your car in person";
    const defaultOfferText = 'Get a trade-in offer on your car in minutes';

    useEffect(() => {
        // will only show local offer data locally, will catch qa and prod data in those environments
        if (eligibleOffer) {
            setEligibleOfferText(
                `We want to buy your ${eligibleOffer?.vehicleInformation?.profile?.year} ${eligibleOffer?.vehicleInformation?.profile?.make} ${eligibleOffer?.vehicleInformation?.profile?.model}`,
            );
        }
        if (!eligibleOffer) {
            setEligibleOffer(savedEligibleOffer);
        }
        if (!ineligibleOffer) {
            setIneligibleOffer(savedIneligibleOffer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eligibleOffer, ineligibleOffer]);

    const getOfferText = () => {
        if (eligibleOffer) {
            return eligibleOfferText;
        } else if (ineligibleOffer) {
            return ineligibleOfferText;
        } else {
            return defaultOfferText;
        }
    };

    const offerButtonText = eligibleOffer ? 'Schedule in-store appraisal' : 'Get my offer';

    if (eligibleOffer) {
        offerButtonHref = buildScheduleEligibleOfferLink(eligibleOffer.storeId, eligibleOffer.offerCode, 'homepage');
    } else if (ineligibleOffer) {
        offerButtonHref = buildScheduleIneligibleOfferLink();
    }

    const prequalButtonText = isPrequalified ? 'Shop with my budget' : 'Get pre-qualified';
    const buildOfferTrackingPayload = (): ITrackingPayload => ({
        event: ANALYTICS_CONSTANTS.EVENTS.CLICK.CTA,
        linkDetails: {
            name: offerButtonText,
            position: 'Homepage',
        },
    });

    const getPreQualifiedPayload = {
        event: 'ctaClick',
        linkDetails: {
            name: 'Get pre-qualified',
            position: 'prequaltile',
        },
        leadDetail: {
            leadOriginationPage: 'HP_Prequaltile_FF',
            leadType: 'Finance First Prequalification Application',
        },
    };

    const shopWithMyBudgetPayload = {
        event: 'ctaClick',
        linkDetails: {
            name: 'Shop with my budget',
            position: 'shoptile',
        },
        search: {
            initiationMethod: 'Homepage|shop with my budget|shoptile',
        },
    };

    return (
        <Stack sx={{ height: '100%', pt: 6 }} spacing={3} direction={{ xs: 'column', lg: 'row' }}>
            {/* consider making these unique components if productionized */}
            <PromoTile
                text={getOfferText()}
                buttonText={offerButtonText}
                buttonHref={offerButtonHref}
                backgroundImage="/images/promo-banner/your-offer.webp"
                trackingPayload={buildOfferTrackingPayload()}
            />
            <PromoTile
                text={
                    isPrequalified
                        ? 'Browse cars that fit your budget and style'
                        : 'Pre-qualify with no impact to your credit'
                }
                buttonText={prequalButtonText}
                buttonHref={isPrequalified ? '/cars?showreservedcars=false' : '/pre-qual/app?op=homebase_promo_tile'}
                backgroundImage="/images/promo-banner/promo-prequal.webp"
                trackingPayload={isPrequalified ? shopWithMyBudgetPayload : getPreQualifiedPayload}
            />
        </Stack>
    );
};

export default HomeOptimizationTestPromoBanner;
